// Bağımlılıksız: üst bar rozeti (her sayfadaki _app paketi) bunu içe aktarır; akış yardımcıları buraya girmez.
/**
 * Ç7: oyuncunun kendi kartlarındaki tebrik sayılarının son görüldüğü hâli (yalnız bu tarayıcı).
 * Kişisel veri yok: kart kimliği ve sayı. Depolama kapalıysa ya da kayıt yoksa sayım 0 döner.
 */
const KEY_PREFIX = 'tenis.feed.congratsSeen.';
const MAX_ENTRIES = 60;

type Seen = { at: number; counts: Record<string, number> };
type OwnEvent = Pick<LeagueFeed.Event, 'id' | 'olusturma' | 'tebrik_sayisi'>;

const key = (viewerId: string) => `${KEY_PREFIX}${viewerId}`;

export function readCongratsSeen(
  viewerId: string,
  storage?: Pick<Storage, 'getItem'>,
): Seen | null {
  try {
    const raw = (storage || window.localStorage).getItem(key(viewerId));
    const value = raw ? JSON.parse(raw) : null;
    if (!value || typeof value.at !== 'number' || !value.counts || typeof value.counts !== 'object')
      return null;
    return value;
  } catch {
    return null;
  }
}

/** Son görülenden bu yana gelen tebrikler; ilk artış olan kart (yeniden eskiye sıradaki ilk). */
export function congratsSince(
  viewerId: string,
  own: OwnEvent[],
  storage?: Pick<Storage, 'getItem'>,
): { count: number; firstId: string | null } {
  const seen = readCongratsSeen(viewerId, storage);
  if (!seen) return { count: 0, firstId: null };
  let count = 0;
  let firstId: string | null = null;
  own.forEach(event => {
    const before = seen.counts[event.id];
    let delta = 0;
    if (typeof before === 'number') delta = Math.max(0, event.tebrik_sayisi - before);
    else if (event.olusturma > seen.at) delta = event.tebrik_sayisi;
    if (delta > 0) {
      count += delta;
      if (!firstId) firstId = event.id;
    }
  });
  return { count, firstId };
}

export function saveCongratsSeen(
  viewerId: string,
  own: OwnEvent[],
  storage?: Pick<Storage, 'setItem'>,
  now = Date.now(),
): void {
  try {
    const counts = Object.fromEntries(
      own.slice(0, MAX_ENTRIES).map(event => [event.id, event.tebrik_sayisi]),
    );
    (storage || window.localStorage).setItem(key(viewerId), JSON.stringify({ at: now, counts }));
  } catch {
    // Depolama kapalı: çip gösterilmez, akış etkilenmez.
  }
}

/** Akış görülünce (sayılar kaydedilince) üst bar rozeti sıfırlanır. */
export const CONGRATS_SEEN_EVENT = 'tenis:congrats-seen';
